import useAuth from '@hooks/useAuth'
import React from 'react'
import NotFound from './components/NotFound'
import Guest from './components/Guest'
import Member from './components/Member'
import Owner from './components/Owner'

export default function InviteClub({ club }: Props) {
    const auth = useAuth<Resources.Customer>()

    if (!club) {
        return <NotFound />
    } else if (auth.user.club?.id === club.id) {
        return <Owner club={club} />
    } else if (auth.user.membership?.club.id === club.id) {
        return <Member club={club} />
    } else {
        return <Guest club={club} />
    }
}

interface Props {
    club: Resources.ClubPartial | undefined
}